import React from 'react';
import { ProtectedLayout } from '../components/layout/ProtectedLayout';
import { ChecklistPanel } from '../components/checklist/ChecklistPanel';

const ChecklistPage: React.FC = () => (
  <ProtectedLayout>
    {({ user }) => (
      <div className="space-y-8">
        <header className="rounded-xl border border-border bg-card p-6 shadow-sm">
          <h1 className="text-3xl font-semibold text-foreground">Checklist</h1>
          <p className="mt-2 text-sm text-muted-foreground">
            Manage shared tasks and stay on top of daily goals.
          </p>
        </header>
        <ChecklistPanel canManage={user.is_staff || user.username.toLowerCase() === 'admin'} />
      </div>
    )}
  </ProtectedLayout>
);

export default ChecklistPage;
